import styled from '@emotion/styled'

import { TabLabelWithWT } from '@f-fertighaus/applications/Next/components/common/navigation/tabs/TabLabel'
import { TabsList } from '@f-fertighaus/applications/Next/components/common/navigation/tabs/TabsList'
import {
  HdpNavigationTab,
  useActiveTabs
} from '@f-fertighaus/applications/Next/components/common/navigation/tabs/useActiveTabs'
import { shadow } from '@f-fertighaus/applications/Next/config/styles'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { transientOptions } from '@f-fertighaus/applications/Next/utils/transientOptions'
import { isNotEmptyArray } from '@f-fertighaus/applications/Next/utils/typeguards/isNotEmptyArray'
import { COMMON_TAB_WT_PAYLOAD_PROPS } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/HouseSections'

export const SECTION_NAV_HEIGHT = 48

export const HouseSectionsNavigation = () => {
  const {
    state: { floor_plans }
  } = useHouseDetail()
  const {
    activeTabIndex,
    handleTabClick,
    shouldShowOnDesktop
  } = useActiveTabs()

  return (
    <TabsWrapper $shouldShowOnDesktop={shouldShowOnDesktop}>
      <TabsList
        activeTabIndex={activeTabIndex}
        handleTabChange={handleTabClick}>
        <TabLabelWithWT
          label={t('houseDetailPage.overview')}
          index={HdpNavigationTab.overview}
          wtPayload={{
            ...COMMON_TAB_WT_PAYLOAD_PROPS({
              wtLabel: 'overview-section',
              label: t('houseDetailPage.overview')
            })
          }}
        />
        <TabLabelWithWT
          label={t('houseDetailPage.floor_plans.title')}
          index={HdpNavigationTab.floorPlans}
          wtPayload={{
            ...COMMON_TAB_WT_PAYLOAD_PROPS({
              wtLabel: 'floor-plans-section',
              label: t('houseDetailPage.floor_plans.title')
            })
          }}
          style={{ display: isNotEmptyArray(floor_plans) ? 'flex' : 'none' }}
        />
        <TabLabelWithWT
          label={t('houseDetailPage.details')}
          index={HdpNavigationTab.details}
          wtPayload={{
            ...COMMON_TAB_WT_PAYLOAD_PROPS({
              wtLabel: 'details-section',
              label: t('houseDetailPage.details')
            })
          }}
        />
        <TabLabelWithWT
          label={t('houseDetailPage.price')}
          index={HdpNavigationTab.price}
          wtPayload={{
            ...COMMON_TAB_WT_PAYLOAD_PROPS({
              wtLabel: 'price-section',
              label: t('houseDetailPage.price')
            })
          }}
        />
        <TabLabelWithWT
          label={t('houseDetailPage.vendor.tab-name')}
          index={HdpNavigationTab.vendor}
          wtPayload={{
            ...COMMON_TAB_WT_PAYLOAD_PROPS({
              wtLabel: 'vendor-section',
              label: t('houseDetailPage.vendor.tab-name')
            })
          }}
        />
      </TabsList>
    </TabsWrapper>
  )
}

const GAP_BETWEEN_NAVBAR_AND_THE_SCREEN_TOP_ON_MOBILE = 1

export const TabsWrapper = styled('div', transientOptions)<{
  $shouldShowOnDesktop?: boolean
}>`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
  transition: 0.3s ease;
  box-shadow: ${shadow.card};

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100vw;
    transform: translateX(${({ theme }) => theme.spacing(-2)})
      translateY(-${GAP_BETWEEN_NAVBAR_AND_THE_SCREEN_TOP_ON_MOBILE}px);
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    position: fixed;
    height: ${SECTION_NAV_HEIGHT}px;
    left: 0;
    padding: ${({ theme }) => theme.spacing(0, 4)};
    background-color: ${({ theme }) => theme.palette.common.white};
    transform: translateY(
      ${({ $shouldShowOnDesktop }) => ($shouldShowOnDesktop ? '0' : '-100%')}
    );

    > div {
      max-width: 1160px;
      margin: auto;
    }
  }
`
